// extracted by mini-css-extract-plugin
module.exports = {"video-container":"VideoPanel_video-container__Wpwd_","item-centered":"VideoPanel_item-centered__rMBhQ"};